export const fieldLabels = {
  name: "Name",
  legalName: "Legal Name",
  acronym: "Acronym",
  recognitionNumber: "Recognition Number",
  email: "Email",
  website: "Website",
  listOfStandardFeesUrl: "List of Standard Fees URL",
  hasCompanyNumber: "Is the organisation registered with Companies House in the UK?",
  companyNumber: "Registered company number",
  hasCharityNumber: "Is the organisation registered with The Charity Commission in England and Wales?",
  charityNumber: "Registered charity number",
  isOtherUkLegalEntity: "Is the organisation another kind of legal entity in the UK, such as a public body or further/higher education institution?",
  otherLegalEntityType: "Other legal entity type",
  isRegisteredInOtherCountry:
    "Is the organisation registered in another country?",
  otherCountryOfRegistration: "Main country of registration",
  otherCountryIdentifier: "Registration number in that country",
  isIndividualOrPartnership:
    "Is the organisation an individual (sole trader) or a partnership (not including Limited Liability Partnerships)?",
  ofqualRecognisedOnDate: "Recognised On",
  ofqualSurrenderedDate: "Surrendered On",
  ofqualWithdrawnOnDate: "Withdrawn On",
  cceaRecognisedOnDate: "CCEA Regulation Recognised On",
  cceaSurrenderedDate: "CCEA Regulation Surrendered On",
  cceaWithdrawnOnDate: "CCEA Regulation Withdrawn On",
  line1: "Line 1",
  line2: "Line 2",
  line3: "Line 3",
  line4: "Line 4",
  postCode: "Post Code",
  country: "Country",
  phoneNumber: "Phone Number",
  meetingDate: "Date and time (dd/mm/yyyy hr:mn)",
  meetingDateShortLabel: "Date and time",
  engagementEventType: "Event type",
  meansOfCommunicationType: "Means of communication",
  notes: "Notes",
  id: "id",
  wasAttended: "PAO attended?",
};

export const applicationFieldLabels = {
  c1bReviewCompletedDate: "Date C.1(b) review completed",
  dReviewCompletedDate: "Date D review completed",
  mainReviewCompletedDate: "Date review completed",
  reviewOutcome: "Review Outcome",
  // review files
  internalMeetingDate: "Date of application review meeting",
  internalMeetingOutcome: "Application review meeting outcome",
  panelMeetingDate: "Panel meeting date",
  panelDecision: "Panel decision",
  // meeting notes files
  dateOfDecisionLetter: "Date of decision letter",

  feedbackMeetingRequested: "Feedback meeting requested",
  feedbackMeetingDate: "Date of feedback meeting",
  feedbackMeetingNotes: "Feedback meeting notes",

  mainReviewerUPN: "Main reviewer upn",
  mainReviewerDisplayName: "Main reviewer name",
  c1bReviewerUPN: "C.1(b) reviewer upn",
  c1bReviewerDisplayName: "C.1(b) reviewer name",
  dReviewerUPN: "D reviewer upn",
  dReviewerDisplayName: "D reviewer name"
};
